var app = angular.module('leonardo');

var FormText = function(FilterService) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      maxlength: '=ngMaxLength',
      minlength: '=ngMinlength',
      patternExp: '=',
      patternText: '=',
      blur: '&ngBlur',
      focus: '&ngFocus',
      onSubmit: '&',
      label: '@',
      inline: '=',
      filter: '@',
      placeholder: '@',
      clearText: '=',
      ngChange: '&',
      debounce:'=?'
    },
    templateUrl: 'views/templates/form/form-text.html',
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];

      scope.debounce = !isNull(scope.debounce) ? scope.debounce : 0;

      scope.$watch('value', function (value) {
        scope.ngModelCtrl.$setViewValue(value);
        if (scope.filter) {
          FilterService.setFilter(scope.filter, scope.value);
        }
      });

      scope.ngModelCtrl.$render = function () {
        scope.value = scope.ngModelCtrl.$viewValue;
        if (!scope.value && scope.filter) {
          scope.value = FilterService.getFilter(scope.filter);
        }
      };

      scope.clear = function() {
        if (scope.ngModelCtrl.$viewValue !== '') {
          scope.ngModelCtrl.$setViewValue('');
          scope.value = scope.ngModelCtrl.$viewValue;
          if (scope.filter) {
            FilterService.setFilter(scope.filter, scope.value);
          }
          scope.onSubmit();
        }
      };

      element.find('input').bind("keydown keypress", function (event) {
        if (event.keyCode === 13) {
          scope.$apply(function () {
            scope.onSubmit();
          });
          event.preventDefault();
        }
      });

    }
  };
};

app.directive('formText', ['FilterService', FormText]);